import React, { Component } from "react";
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import isEmpty from 'lodash/isEmpty';

import "../../css/sub-nav.css";

class CustomerNav extends Component {
	render() {
		return (
			<div className="sub_nav">
				<div className="title">Account Menu</div>

				<nav>
					<NavLink activeClassName="active" to={"/customer/account-info"}>
						Account Info
					</NavLink>
					{!isEmpty(this.props.user) &&
					<NavLink activeClassName="active" to={"/customer/orders"}>
						View Orders
					</NavLink>
					}
					<NavLink activeClassName="active" to={"/customer/change-password"}>
						Change Password
					</NavLink>
					<NavLink activeClassName="active" to={"/customer/logout"}>
						Logout
					</NavLink>
				</nav>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
    return {
        user: state.user.customer.user,
    };
};

export default connect(
    mapStateToProps, {}
)(CustomerNav);



// WEBPACK FOOTER //
// ./src/components/customer/CustomerNav.js